// 按需导入 polyfills 以支持旧版浏览器
import "core-js/es/promise";
import "core-js/es/object/assign";
import "core-js/es/array/includes";
import "core-js/es/string/includes";
import "core-js/es/array/find";
import "core-js/es/array/from";
import "core-js/es/set";
import "core-js/es/map";
import "regenerator-runtime/runtime";

import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "./style.css";
import "./styles/animations.css"; // 导入动画样式
import { i18n } from "./i18n";
import { initAnimationObserver } from './utils/animationObserver'; // 导入动画观察器
import { designAssetStyle } from "./utils/designAsset";

const app = createApp(App);
app.use(router).use(i18n);

document.documentElement.style.setProperty(
  "--title-snow",
  designAssetStyle("pc/SVG/snowflakeLightBlue.svg"),
);

// 路由切换后初始化动画观察器
router.isReady().then(() => {
  app.mount("#app");
  // 初始页面加载后初始化
  initAnimationObserver();
});

router.afterEach(() => {
  // 路由切换后延迟初始化，确保 DOM 已更新
  setTimeout(() => {
    initAnimationObserver();
  }, 100);
});
